/**
 * Configuration des liaisons carte ProOffers ↔ plan backend (par _id).
 * Ces IDs correspondent aux plans gérés dans l'admin (/plan).
 * Si un plan est recréé (nouvel _id), mettre à jour la valeur ici.
 */
export const PRO_PLAN_IDS = {
  starter: "6a8a99b0f3fc1ebb4c021e6d",
  growth: "6a8ae98da1bb1768730104d0",
  scale: "6a8aead3a1bb17687301050c",
  // Plan gratuit par défaut (agence).
  free: "6a8b48adffba4537aa97d926",
};

// Plans « Agent indépendant » (créés dans l'admin /plan avec les mêmes
// paramètres que les plans Pro). À mettre à jour si les plans sont recréés.
export const AGENT_PLAN_IDS = {
  decouverte: "6acaaacbf46dc731d2d805db",
  starter: "6acaaacbf46dc731d2d805dc",
  croissance: "6acaaacbf46dc731d2d805dd",
  // Plan gratuit par défaut (agent indépendant).
  free: "6acb7ed0ed630f8679d805db",
};

export const WHITE_PLAN_IDS = {
  essentiel: "6a8aeb5da1bb17687301052a",
  croissance: "6a8aec3ca1bb1768730105a9",
  reseau: "6a8aec7fa1bb1768730105ca",
  // groupe : aucun plan backend (carte « Sur devis »)
};

export const INVESTOR_PLAN_IDS = {
  starter: "6a00000000000000000000a1",
  growth: "6a00000000000000000000a2",
  scale: "6a00000000000000000000a3",
  // portfolio : aucun plan backend (carte « Sur devis »)
  // Plan gratuit par défaut (investisseur).
  free: "6a8c4296027f029bf71c6c6a",
};

// Plans « Chasseur immobilier ». « Pack Découverte Chasseur immo » réutilise le
// plan gratuit « Découverte Chasseur immobilier » ; « Pack chasseur Pro » a été
// créé dans l'admin /plan (59 € HT/mois, essai 90 jours).
export const HUNTER_PLAN_IDS = {
  decouverte: "6aad757c5e47276e4e549d70",
  pro: "6accf3dbe8b5f3cfbed805db",
};

// Plans « Diagnostiqueur immobilier » (créés dans l'admin /plan).
export const DIAGNOSTIC_PLAN_IDS = {
  decouverte: "6ad23a718d92c6421957cc81",
  pro: "6ad23a718d92c6421957cd18",
};

// Plans « Décorateur d'intérieur » (créés dans l'admin /plan).
export const DECORATOR_PLAN_IDS = {
  decouverte: "6ad8dc5024256e68593d5e90",
  pro: "6ad8dc5024256e68593d5e9c",
};

// Plans « Particuliers » (offres individuelles). Le plan gratuit par défaut est
// « Découverte AnyHomes Particuliers » (géré hors de cette liste).
export const INDIVIDUAL_PLAN_IDS = {
  decouverte: "6a47b467661aa4e94b4d373e",
  solo: "6ab137d8ec7143c15bccdcc3",
  duo: "6ab1535dbd7d7f121fa46ca3",
};